import { BasicAuthDeviation as ApiBasicAuthDeviation } from '@infuse/api/e-connector/basic-auth-deviation';
import { BasicAuthDeviation } from './model';

export const mapToDomain = (apiBasicAuthDeviation: ApiBasicAuthDeviation): BasicAuthDeviation => {
  return { ...apiBasicAuthDeviation };
};
